module.exports = __webpack_public_path__ + "static/media/plus.884859df.svg";